export default __webpack_public_path__ + "static/media/perfect-kraver.58200256.svg";